import {
  inject, onMounted, onUpdated, watch,
} from 'vue';
import { vueAdaptAll } from '../../libs/cifra/vue_adapters';

// Hay que pasr aquí CifraGlobal porque dentro de cargarComponentesJquery cuando
// recarga ya no existe este inject, devuelve null no sé muy bien la razón
export function cargarComponentesJquery(CifraGlobal, elemento) {
  CifraGlobal.App.loadComponents(elemento);
  // Adaptadores para los componentes jquery
  vueAdaptAll(elemento);
}

// element debe ser una referencia (ref de vue)
export function useJqueryComponents(element, opciones) {
  const opts = {
    update: true,
    ...opciones,
  };

  const CifraGlobal = inject('CifraGlobal');

  const cargar = () => {
    cargarComponentesJquery(CifraGlobal, element.value);
  };

  watch(element, cargar);

  onMounted(cargar);

  if (opts.update) {
    onUpdated(cargar);
  }
}

// @deprecated: Usar composition api (useJqueryComponents)
export default {
  mounted() {
    this.loadJqueryComponents();
  },
  methods: {
    loadJqueryComponents() {
      this.$Cifra.App.loadComponents(this.$el);
      // Adaptadores para los componentes jquery
      vueAdaptAll(this.$el);
    },
  },
};
